import gql from 'graphql-tag';

const GET_STOCK_BY_STORE_SKU = gql`
    query getStockByStoreAndSKU ($storeId: String!, $refId: String!) {
        getStockByStoreAndSKU (storeId: $storeId, refId: $refId) {
            status
            message
            data {
                stock
            }
        }
    }
`;

export default GET_STOCK_BY_STORE_SKU;
